import { render } from "./AddEnvironmentAPIExpress.vue?vue&type=template&id=1ef10b16&scoped=true"
import script from "./AddEnvironmentAPIExpress.vue?vue&type=script&lang=js"
export * from "./AddEnvironmentAPIExpress.vue?vue&type=script&lang=js"

import "./AddEnvironmentAPIExpress.vue?vue&type=style&index=0&id=1ef10b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef10b16"]])

export default __exports__